import { render } from "./GiftAid.vue?vue&type=template&id=7217da76&scoped=true"
import script from "./GiftAid.vue?vue&type=script&lang=js"
export * from "./GiftAid.vue?vue&type=script&lang=js"

import "./GiftAid.vue?vue&type=style&index=0&id=7217da76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7217da76"]])

export default __exports__